
import React from 'react';

const ItemsTable = ({ items }) => {
  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold text-[#DBAE6E] mb-2">Items</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#222] border-b border-[#DBAE6E]/30">
              <th className="px-4 py-3 text-sm font-semibold text-[#DBAE6E]">Name</th>
              <th className="px-4 py-3 text-sm font-semibold text-[#DBAE6E]">Size</th>
              <th className="px-4 py-3 text-sm font-semibold text-[#DBAE6E]">Color</th>
              <th className="px-4 py-3 text-sm font-semibold text-[#DBAE6E]">Quantity</th>
              {items.some((item) => item.price) && (
                <th className="px-4 py-3 text-sm font-semibold text-[#DBAE6E]">Price</th>
              )}
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={index}
                className="border-b border-[#DBAE6E]/10 hover:bg-[#333] transition-colors"
              >
                <td className="px-4 py-3 text-sm text-white">{item.name || '-'}</td>
                <td className="px-4 py-3 text-sm text-white">{item.size || '-'}</td>
                <td className="px-4 py-3 text-sm text-white">{item.color || '-'}</td>
                <td className="px-4 py-3 text-sm text-white">{item.quantity || '-'}</td>
                {items.some((item) => item.price) && (
                  <td className="px-4 py-3 text-sm text-white">
                    {item.price ? `${item.price} Rs` : '-'}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemsTable;
